/**
 * Beta Mode helper — single source of truth for the "is the beta program
 * still running?" question. Read once at module load; a redeploy flips it.
 *
 * Values:
 *   - "active"  → the 3-month beta is still open. All self-serve paid
 *                 signup surfaces (Continuity System "Get Started") are
 *                 gated behind an "Available after Beta" state. Only the
 *                 "Join Beta" and "Request Invitation" doors are open.
 *   - "ended"   → beta window is over. All Get Started surfaces come back
 *                 to their normal self-serve behaviour.
 *
 * Set in ``frontend/.env`` as ``REACT_APP_BETA_MODE=active|ended``.
 * Change requires a frontend redeploy (Create React App bakes env at build).
 *
 * Added Session 279 (Feb 2026) — see PRD entry.
 */

const RAW = (process.env.REACT_APP_BETA_MODE || 'active').trim().toLowerCase();

export const isBetaActive = () => RAW !== 'ended';
